import React from 'react';

import { useOrientation } from '@/lib/hooks/useOrientation';

import { WEEK_DAYS } from '../../constants';
import Checkbox from './components/Checkbox';
import styles from './index.module.scss';

type RepeatTimeSelectorProps = {
  repeatTimes: number[];
  updateRepeatTimes: (newRepeatTimes: number[]) => void;
  closeSelector: () => void;
};

const RepeatTimeSelector = ({
  repeatTimes,
  updateRepeatTimes,
  closeSelector,
}: RepeatTimeSelectorProps) => {
  const updateWeekDaySelect = (optionValue: number, isSelected: boolean) => {
    const newRepeatTimes = isSelected
      ? repeatTimes.filter((item) => item !== optionValue)
      : [...repeatTimes, optionValue].sort();
    updateRepeatTimes(newRepeatTimes);
  };

  const isLandscape = useOrientation() === 'LANDSCAPE';

  return isLandscape ? (
    <div className={styles['repeatTimeSelectorContainer-landscape']}>
      <h5>重複</h5>
      <button onClick={closeSelector}>Done</button>
      <ul>
        {WEEK_DAYS.map((weekDay, index) => {
          const isSelected = repeatTimes.includes(index);
          return (
            <li
              key={weekDay}
              onClick={() => updateWeekDaySelect(index, isSelected)}
              data-selected-weekday={isSelected}
            >
              <p>{weekDay}</p>
            </li>
          );
        })}
      </ul>
    </div>
  ) : (
    <div className={styles.repeatTimeSelectorContainer}>
      <ul>
        {WEEK_DAYS.map((weekDay, index) => {
          const isSelected = repeatTimes.includes(index);
          return (
            <li
              key={weekDay}
              onClick={() => updateWeekDaySelect(index, isSelected)}
            >
              <Checkbox isChecked={isSelected} />
              <p>{weekDay}</p>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default RepeatTimeSelector;
